module.exports = __webpack_public_path__ + "static/media/Alta-thumb.f5fb70b7.jpg";